export const GET_DASHBOARD_DATA = `https://ai-workbench.aisf.t-systems.net/api/hpcl_analytics_pro/v1/dashboard_chart/`;
export const GENERATE_GRAPH_BY_QUERY = `https://ai-workbench.aisf.t-systems.net/api/hpcl_analytics_pro/v1/generate_graph?query=`;
export const GENERATE_CUSTOM_GRAPH_BY_QUERY = `https://ai-workbench.aisf.t-systems.net/api/upload-custom-csv/v1/generate_custom_graph?query=`;
export const NEW_DAHSBOARD_PAGE_DATA_URL =
  "https://ai-workbench.aisf.t-systems.net/api/hpcl_analytics_pro/v1/";
